// extracted by mini-css-extract-plugin
export default {"view-mode":"J6EfmKgzXn3K_J1e3kaP"};